(() => {
  if (window.TemporiQuickOrderCart) return;
  let busy = false;
  const count = (cart, id) => cart.items.filter(item => String(item.variant_id) === String(id)).reduce((total, item) => total + Number(item.quantity), 0);
  const readCart = async root => {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('cart_unavailable');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('cart_unavailable');
    return cart;
  };
  const add = async (rows, root = window.Shopify?.routes?.root || '/') => {
    if (busy) return { status: 'busy' };
    if (!rows.length) return { status: 'empty' };
    busy = true;
    try {
      // Snapshot the explicit selection before any asynchronous work.
      const requested = rows.map(row => ({ id: String(row.id), quantity: Number(row.quantity), rule: { ...row.rule } }));
      if (new Set(requested.map(row => row.id)).size !== requested.length) return { status: 'invalid' };
      let before;
      try { before = await readCart(root); } catch (_) { return { status: 'unavailable' }; }
      const invalid = requested.filter(row => !window.TemporiQuantityRules.valid(row.quantity, row.rule, count(before, row.id)));
      if (invalid.length) return { status: 'invalid', cart: before, invalidIds: invalid.map(row => row.id) };
      let response;
      try {
        response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: requested.map(({ id, quantity }) => ({ id, quantity })) }),
        });
      } catch (_) {
        // A transport error does not prove the mutation was rejected. Never retry automatically.
        return { status: 'uncertain' };
      }
      let after;
      try { after = await readCart(root); } catch (_) { return { status: 'uncertain' }; }
      const items = requested.map(row => {
        const previousQuantity = count(before, row.id);
        const cartQuantity = count(after, row.id);
        const observedIncrease = Math.max(0, cartQuantity - previousQuantity);
        return { id: row.id, requested: row.quantity, previousQuantity, cartQuantity, remaining: Math.max(0, row.quantity - observedIncrease) };
      });
      // These are observed cart quantities, not attribution: another cart control may have changed them.
      return { status: items.every(item => item.remaining === 0) ? 'complete' : 'partial', accepted: response.ok, cart: after, items };
    } finally { busy = false; }
  };
  window.TemporiQuickOrderCart = { add };
})();
